module.exports = __webpack_public_path__ + "img/revdojo_default.ba57a8a1.jpg";